
import React, { createContext, useContext, useState } from 'react';

interface DemoContextType {
  isDemoMode: boolean;
  setDemoMode: (enabled: boolean) => void;
  demoUser: {
    id: string;
    email: string;
    full_name: string;
  } | null;
}

const DemoContext = createContext<DemoContextType>({} as DemoContextType);

export const useDemo = () => {
  const context = useContext(DemoContext);
  if (!context) {
    throw new Error('useDemo must be used within a DemoProvider');
  }
  return context;
};

export const DemoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDemoMode, setIsDemoMode] = useState(false);

  const demoUser = {
    id: 'demo-user-123',
    email: 'demo@meditation.app',
    full_name: 'Demo User'
  };

  const setDemoMode = (enabled: boolean) => {
    setIsDemoMode(enabled);
    if (enabled) {
      console.log('Demo mode activated');
    }
  };

  const value = {
    isDemoMode,
    setDemoMode,
    demoUser: isDemoMode ? demoUser : null,
  };

  return <DemoContext.Provider value={value}>{children}</DemoContext.Provider>;
};
